var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentation = function SvgPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 3.818a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 13h8a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h8v1.586l-4.707 4.707a1 1 0 1 0 1.414 1.415L11 21.233v2.585a1 1 0 0 0 2 0v-2.585l3.293 3.293a1 1 0 0 0 1.414-1.415L13 18.404zm2.22-11.624a1 1 0 0 1 1.335-.208l3 2a1 1 0 0 1-1.11 1.664L16.209 7.16l-3.427 4.284a1 1 0 0 1-1.488.082L9 9.234l-3.293 3.292a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l2.21 2.21z",
    clipRule: "evenodd"
  })));
};
export default SvgPresentation;